import { FrLogService } from './shared/services/fr-log.service';

export function indexedDbMigrationFactory() {
    const logError = (message?: string, ...optionalParams: unknown[]) : void => {
        const logService = new FrLogService();
        console.error(message, optionalParams);
        logService.logFrError(new Error(message));
    }
    const logTrace = (message?: string, properties?: { [key: string]: unknown }) : void => {
        const logService = new FrLogService();
        console.log(message, properties);
        logService.logFrTrace(message ?? '', properties);
    }
    return {
        1: (db: IDBDatabase, transaction: IDBTransaction) => {
            transaction.oncomplete = () => {
                logTrace('Database version upgrade transaction committed successfully (V1).');
            };
            transaction.onerror = (event) => {
                logError('Migration transaction failed:', (event.target as IDBTransaction).error);
            };
        },
        2: (db: IDBDatabase, transaction: IDBTransaction) => {
            transaction.oncomplete = () => {
                logTrace('Database version upgrade transaction committed successfully (V2).');
            };
            transaction.onerror = (event) => {
                logError('Migration transaction failed:', (event.target as IDBTransaction).error);
            };
            const reportsStore = transaction.objectStore('reports');
            const cursorRequest = reportsStore.openCursor();
            cursorRequest.onerror = (cursorEvent: Event) => {
                logError('Reports cursor error: ', (cursorEvent.target as IDBRequest).error)
            };
            cursorRequest.onsuccess = (cursorEvent: Event) => {
                logTrace('Cursor opened successfully for migration V2.');
                logTrace('Processing records for V2...');
                const cursor = (cursorEvent.target as IDBRequest)
                    .result as IDBCursorWithValue | null;
                if (cursor) {
                    const oldRecord = cursor.value;
                    const newRecord = structuredClone(oldRecord);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    newRecord.report.issues?.forEach((issue: any) => {
                    if (issue.problemId && issue.problemCategory) {
                        issue.problems = [];
                        issue.problems.push({
                        problemId: issue.problemId,
                        problemCategoryId: issue.problemCategory
                        });

                        delete issue.problemId;
                        delete issue.problemCategory;
                    }
                    });
                    cursor.update(newRecord);
                    cursor.continue();
                } else {
                    logTrace('Data migration V2 completed.');
                }
            };
        },
        3: (db: IDBDatabase, transaction: IDBTransaction) => {
            transaction.oncomplete = () => {
                logTrace('Database version upgrade transaction committed successfully (V3).');
            };
            transaction.onerror = (event) => {
                logError('Migration transaction failed:', (event.target as IDBTransaction).error);
            };
        },
        4: (db: IDBDatabase, transaction: IDBTransaction) => {
            transaction.oncomplete = () => {
                logTrace('Database version upgrade transaction committed successfully (V4).');
            };
            transaction.onerror = (event) => {
                logError('Migration transaction failed:', (event.target as IDBTransaction).error);
            };
        }
    };
}